import { httpClient } from './httpClient';

export const getPromotionCode = async (couponCode) => {
  const response = await httpClient.post(`/coupons/promotion-code`, { coupon_code: couponCode })
  return response.data
}

export const getCoupons = async () => {
  const response = await httpClient.get(`/coupons/list`);
  return response.data;
}

export const createCoupon = async (payload) => {
  const response = await httpClient.post('/coupons/create', payload);
  return response.data;
}

export const attachDetachCoupon = async (promotion_code, linkage_identifier, coupon_code) => {
  const response = await httpClient.post('/coupons/attach-detach', {
    promotion_code: promotion_code,
    linkage_identifier: linkage_identifier,
    coupon_code: coupon_code,
  });
  return response.data;
}
export const searchCoupon = async (linkage_identifier) => {
  const response = await httpClient.post(`/coupons/search`, {
    linkage_identifier
  });
  return response.data;
}
